import { pushFaroEvent } from '@/shared/lib';

import {
  RECORDING_EVENT_PREFIX,
  RecordingEventAttributes,
  RecordingEventName,
} from '../config';

const toFaroAttributes = (
  attributes: RecordingEventAttributes,
): Record<string, string> =>
  Object.entries(attributes).reduce<Record<string, string>>(
    (result, [key, value]) =>
      value === undefined || value === null
        ? result
        : { ...result, [key]: String(value) },
    {},
  );

export const trackRecordingEvent = (
  name: RecordingEventName,
  attributes: RecordingEventAttributes = {},
): void => {
  pushFaroEvent(
    `${RECORDING_EVENT_PREFIX}${name}`,
    toFaroAttributes(attributes),
  );
};
